/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const Book32 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 3c.8 0 1.5.3 2 .8.5-.5 1.2-.8 2-.8h10c.6 0 1 .4 1 1h2c.6 0 1 .4 1 1v23c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h2c0-.6.4-1 1-1Zm16 3h-1v18c0 .6-.4 1-1 1H18c-.6 0-1 .4-1 1s-.4 1-1 1h14zM3 6H2v21h14c-.6 0-1-.4-1-1s-.4-1-1-1H4c-.6 0-1-.4-1-1zm11-1H5v18h9c.8 0 1.5.3 2 .8.5-.5 1.2-.8 2-.8h9V5h-9c-.6 0-1 .4-1 1s-.4 1-1 1-1-.4-1-1-.4-1-1-1m2 4c.6 0 1 .4 1 1v9c0 .6-.4 1-1 1s-1-.4-1-1v-9c0-.6.4-1 1-1m-4 8c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1s.4-1 1-1Zm12 0c.6 0 1 .4 1 1s-.4 1-1 1h-4c-.6 0-1-.4-1-1s.4-1 1-1Zm-12-4c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1s.4-1 1-1Zm12 0c.6 0 1 .4 1 1s-.4 1-1 1h-4c-.6 0-1-.4-1-1s.4-1 1-1ZM12 9c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1s.4-1 1-1Zm12 0c.6 0 1 .4 1 1s-.4 1-1 1h-4c-.6 0-1-.4-1-1s.4-1 1-1Z"
    />
  </svg>
);

export const __descriptor_Book = {
  name: "Book",
  instances: [{ size: 32, Component: Book32 }],
} as const;
